import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';
import sessionDataEntry from 'cccisd-laravel-assignment/dist/components/navigations/sessionDataEntry';
import outcomesDataEntry from 'cccisd-laravel-assignment/dist/components/navigations/outcomesDataEntry';
import withModules from 'cccisd-laravel-assignment/dist/components/navigations/withModules';

const navigations = [sessionDataEntry, outcomesDataEntry, withModules, courseWrapper];

export default navigations;
